<div class="lp">

    <a (click)="click()">
        <img src="assets/img/imgpsh_fullsize_anim.jpg" alt="">
    </a>
</div>
<!-- <p><b>Header Enrichment</b></p>
<p>{{strResponse}}</p> -->
<!-- Modal -->
<div class="popup" *ngIf="wifiModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>
                <!-- <a type="button" routerLink="/lp" class="btn btn-primary" (click)="closeModal()">OK</a> -->
            </div>
        </div>
    </div>
</div>

<div class="popup" *ngIf="subModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <h3 class="modal-title modal-title-color">Thanks to subscribe to the service and make the ultimate use
                    of the premium content.</h3>
                <a type="button" class="btn btn-primary" (click)="closeModal()">OK</a>
            </div>
        </div>
    </div>
</div>

<div class="popup" *ngIf="dayModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title modal-title-color">We are unable to process you request. Kindly try again after
                    few days.</h3>
                <a type="button" class="btn btn-primary" href="://www.google.com/">OK</a>
            </div>
        </div>
    </div>
</div>

<div class="popup" *ngIf="invalidNo">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title modal-title-color">{{msg}}</h3>
                <a type="button" class="btn btn-primary" (click)="closeinvalidModal()">OK</a>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.9)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: #fff;">Loading...</p>
</ngx-spinner>